import { CreateProject, EditProject, Project } from "../types/admin-management";
import { callApiInstance } from "./api";

class ProjectsService {
  async getAllProjects(showInactive: boolean): Promise<Project[]> {
    return (await callApiInstance({ url: `/Project?showInactive=${showInactive}` })).data;
  }
  async createProject(data: CreateProject) {
    return (await callApiInstance({
      url: "/Project",
      method: "POST",
      data,
      headers: {
        "Content-Type": "application/json"
      }
    })).data;
  }
  async getSingleProject(id: number) {
    return (await callApiInstance({ url: `/Project/${id}` })).data;
  }
  async editProject(data: EditProject) {
    return (await callApiInstance({
      url: `/Project/${data.id}`,
      method: "PUT",
      data,
      headers: {
        "Content-Type": "application/json"
      }
    })).data;
  }
  async deleteProject(id: number) {
    return (await callApiInstance({ url: `/Project/${id}`, method: "DELETE" })).data;
  }
}
export const projectsService = new ProjectsService();
